'use strict';

export default {
  SENTINEL: 'sentinel2',
  LANDSAT: 'landsat8',
  BOTH: 'both',
};
